<template>
<div class="form-submission-card-content">
    <div class="row row-cols-2 row-cols-md-3 w-100 mx-auto">
        <response-text
            v-for="(answer, question) of keyValueQuestions"
            :key="question"
            :question="question"
            :answer="answer"
        />
    </div>

    <list-of-operatives-signatures
        class="form-submission-card-content-child"
        :data="[form_submission.signature]"
        :inline_signature="pdf_mode"
        is_nested
    />
</div>
</template>

<script>
import SubmissionTitle from "../submissions/SubmissionTitle";
import SubmissionSubtitle from "../submissions/SubmissionSubtitle";
import ResponseText from "../submissions/responses/ResponseText";
import ListOfOperativesSignatures from '../forms/ListOfOperativesSignatures';

export default {
    name: "FaceFitCertificateContent",
    components: {
        ResponseText,
        SubmissionTitle,
        SubmissionSubtitle,
        ListOfOperativesSignatures,
    },
    props: {
        form_submission: Object,
        pdf_mode: Boolean,
    },
    methods: {
        getIcon(answer) {
            if (answer === null || answer === undefined)
                return `/svg/${resource_group}/answer_adequate.svg`;

            return `/svg/${resource_group}/answer_${answer ? 'correct' : 'incorrect'}.svg`
        },
        getColor(answer) {
            if (answer === null || answer === undefined)
                return 'adequate';

            return answer ? 'positive' : 'negative';
        },
    },
    computed: {
        keyValueQuestions() {
            let values = {};

            this.form_submission.answers.forEach(answer => {
                switch (answer.question.type) {
                    case 'free_text':
                        values[answer.question.question] = answer.answer;
                        break;

                    case 'date':
                        values[answer.question.question] = answer.answer;
                        break;

                    case 'dropdown':
                        values[answer.question.question] = answer.option ? answer.option.label : '';
                        break;

                    case 'dropdown_other':
                        if (answer.option.is_free_text) {
                            values[answer.question.question] = answer.option ? answer.option.label + ' : ' + answer.answer : '';
                        } else {
                            values[answer.question.question] = answer.option ? answer.option.label : '';
                        }
                        break;

                    case 'checkbox':
                        let compiled_answer = '';
                        answer.answers.forEach(answer => {
                            compiled_answer += (answer.option ? answer.option.label : '') + '\n';
                        });
                        compiled_answer += answer.answer;

                        values[answer.question.question] = compiled_answer.trim();
                        break;

                    default:
                        break;
                }
            });

            return values;
        },

        yesNoQuestions() {
            let values = {};

            this.form_submission.answers.forEach(answer => {
                if (answer.question.type === 'yes_no')
                    values[answer.question.question] = answer.answer_yes_no;
            });

            if (Object.keys(values).length === 0) {
                return null;
            }

            return values;
        }
    }
}
</script>
